import React, { useRef, useEffect } from 'react';
import { useLoader } from '@react-three/fiber';
import { TextureLoader } from 'three';
import { useSimulationContext } from '../../providers/SimulationProvider';

function EnvironmentBackground({ environmentId, setIsSceneReady }) {
  const isReadyFired = useRef(false);
  const texture = useLoader(TextureLoader, '/bg/' + environmentId + '.webp');

  useEffect(() => {
    if (isReadyFired.current || !texture || !texture.image?.complete) return;

    const rafId = requestAnimationFrame(() => {
      isReadyFired.current = true;
      setIsSceneReady?.(true);
    });

    return () => cancelAnimationFrame(rafId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [texture]);

  return (
    <mesh position={[0.1, 1.2, -6]} scale={[3.3, 3.3, 3.3]}>
      <planeGeometry />
      <meshBasicMaterial map={texture} />
    </mesh>
  );
}

function Environment({ setIsSceneReady }) {
  const { environmentId } = useSimulationContext();

  return (
    <>
      <ambientLight intensity={1} />
      <directionalLight
        position={[1, 2, 1]}
        intensity={1}
        color={0xffffff}
        castShadow
      />
      <pointLight position={[10, 10, 10]} />
      {environmentId && (
        <EnvironmentBackground
          environmentId={environmentId}
          setIsSceneReady={setIsSceneReady}
        />
      )}
    </>
  );
}

export default Environment;
